module.exports = __webpack_public_path__ + "img/image.7bcf8e6d.svg";